exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settingsBtn[data-v-176aebe7] {\r\n  max-width: 400px;\n}\n.radio[data-v-176aebe7] {\r\n  padding: 5px 8px;\r\n  border: 1px solid #eeeeee;\r\n  border-radius: 3px;\n}\r\n\r\n", ""]);

// exports
